/**
 * Isolated factory for constructing the Piezo sign Worker. The `new Worker(new URL(...,
 * import.meta.url))` form is what webpack 5 uses to emit the worker chunk, but `import.meta` cannot
 * be parsed by the CRA/babel jest transform. Keeping it in this tiny module lets workerPool.ts be
 * unit-tested (tests jest.mock this factory) while production webpack still emits the worker chunk.
 */
export function createSignWorker(): Worker {
  return new Worker(new URL('./signWorker.ts', import.meta.url), { type: 'module' });
}
